export default [
  {
    path: "/finance",
    component: (resolve) => require(["@/vuepage/data-analysis/finance.vue"], resolve),
    meta: [
      {
        name: "数据分析",
      },
      {
        name: "财务汇总",
        activeRoute: "/finance",
      },
    ],
  },
  {
    path: "/user-analysis",
    component: (resolve) => require(["@/vuepage/data-analysis/user.vue"], resolve),
    meta: [
      {
        name: "数据分析",
      },
      {
        name: "用户分析",
        activeRoute: "/user-analysis",
      },
    ],
  },
  {
    path: "/certificate-analysis",
    component: (resolve) => require(["@/vuepage/data-analysis/certificate.vue"], resolve),
    meta: [
      {
        name: "数据分析",
      },
      {
        name: "证书统计",
        activeRoute: "/certificate-analysis",
      },
    ],
  },
  {
    path: "/learn-analysis",
    component: (resolve) => require(["@/vuepage/data-analysis/learn.vue"], resolve),
    meta: [
      {
        name: "数据分析",
      },
      {
        name: "学习统计",
        activeRoute: "/learn-analysis",
      },
    ],
  },
];
